function removeNonApplicableLocalizedElements() {
  const currentDomain = window.location.hostname;
  const domainExtension = currentDomain.split('.').pop();
  const classToKeep = `local-${domainExtension.toLowerCase()}`;

  const classesToRemove = ['local-com', 'local-uk', 'local-fr', 'local-es', 'local-de', 'local-nl'].filter(
    (locale) => locale !== classToKeep
  );

  classesToRemove.forEach((className) => {
    const elements = document.querySelectorAll(`.${className}:not(.${classToKeep})`);

    elements.forEach((element) => {
      element.remove();
    });
  });
}

window.addEventListener('load', removeNonApplicableLocalizedElements);

function responseHelper({ width, on, off = null }) {
  function _getRange(range1, range2) {
    let mediaQueryString;

    if (range1 <= 0) {
      mediaQueryString = `(max-width: ${range2}px)`;
    } else if (range2 <= 0) {
      mediaQueryString = `(min-width: ${range1}px)`;
    }

    return mediaQueryString;
  }

  const media = _getRange(width.split('..')[0], width.split('..')[1]);
  const divElem = document.querySelector('body');

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const _entry of entries) {
        if (window.matchMedia(media).matches) {
          on?.();
        } else {
          off?.();
        }
      }
    });

    resizeObserver.observe(divElem);
  } else {
    console.warn('ResizeObserver is not supported in this browser.');
  }
}

function initSmoothSelect() {
  responseHelper({
    width: '..767',
    on() {
      document.querySelectorAll('.tabs-select').forEach(function (tabSelect) {
        tabSelect.addEventListener('change', function () {
          window.scrollTo({
            top: document.querySelector(this.value).offsetTop,
            behavior: 'smooth',
          });
        });
      });
    },
  });
}

window.addEventListener('load', initSmoothSelect);

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function (...args) {
    return fn.apply(scope, args);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i += 1) {
    const option = selector.options[i];

    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;

      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  if (target.addEventListener) {
    target.addEventListener(eventName, callback, false);
  } else {
    target.attachEvent(`on${eventName}`, callback);
  }
};

Shopify.postLink = function (path, options) {
  const linkOptions = options || {};
  const method = linkOptions.method || 'post';
  const params = linkOptions.parameters || {};

  const form = document.createElement('form');

  form.setAttribute('method', method);
  form.setAttribute('action', path);

  Object.entries(params).forEach(([key, value]) => {
    const hiddenField = document.createElement('input');

    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', value);
    form.appendChild(hiddenField);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options.hideElement || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute('data-default');

    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute('data-default');

    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(_e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);

    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i += 1) {
        opt = document.createElement('option');

        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0; i < values.length; i += 1) {
      const opt = document.createElement('option');

      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * Reveals a payment method that a Shopify payment customization hides, so it can be
 * exercised in a live checkout without ever showing it to customers.
 *
 * `?_pm_unlock=<token>` on any storefront URL stores the token as the `_pm_unlock`
 * cart attribute. The payment customization function stands its whole rule down for
 * a cart presenting the token that rule was configured with, so the hidden method
 * appears in checkout. The attribute rides along with the cart until it is emptied,
 * so the parameter is only needed once per test session.
 *
 * This conceals a payment method, it does not secure one: cart attributes are
 * writable by anyone from the browser.
 */
function applyPaymentUnlockToken() {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('_pm_unlock');

  if (!token) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ attributes: { _pm_unlock: token } }),
  })
    .then((response) => {
      if (!response.ok) return;

      // Drop the token from the address bar once the cart holds it, so it is not
      // carried into analytics, referrers, or a link someone copies out of the bar.
      url.searchParams.delete('_pm_unlock');
      window.history.replaceState({}, '', url.href);
    })
    .catch(() => {
      // Leave the parameter in place so a reload retries.
    });
}

applyPaymentUnlockToken();
